import { createFileRoute } from '@tanstack/react-router';
import CreateContact from '../../../features/baseData/contacts/contact/create';
import {
  CONTACTS_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/kontakte/neu')({
  component: CreateContact,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CONTACTS_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateContactRoute = Route;
